import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable, DropResult } from '@hello-pangea/dnd';
import "./CpntDragAndDropLists.scss";
import { IKeyValueLibelle } from '../models/interfaces/IKeyValueLibelle';
import SpinnerEditeurPro from '../pages/FO/components/SpinnerEditeurPro';
import { Tooltip } from 'react-tooltip';
 
//   const initialSourceTasks: Task[] = [
//     // { id: '1', content: 'Task 1' },
//     // { id: '2', content: 'Task 2' },
//     // { id: '3', content: 'Task 3' },
//   ];
  
//   const initialDestinationTasks: Task[] = [
//     // { id: '4', content: 'Task 4' },
//     // { id: '5', content: 'Task 5' },
//     // { id: '6', content: 'Task 6' },
//   ];


  interface IProps {
    titresource: string,
    source?: IKeyValueLibelle[];
    sourceIsFetching:boolean;
    titredestination: string,
    destination?: IKeyValueLibelle[];
    destinationIsFetching:boolean;
    cmdValider: (retDestination: IKeyValueLibelle[]) => void;
    cmdAnnuler: () => void;
  }

  const CpntDragAndDropLists: React.FC<IProps> = ({
    titresource,
    source,
    sourceIsFetching,
    titredestination,
    destinationIsFetching,
    destination,
    cmdValider,
    cmdAnnuler
  }: IProps) => {


    

    const [sourceTasks, setSourceTasks] = useState<IKeyValueLibelle[]|undefined>([]);
    const [destinationTasks, setDestinationTasks] = useState<IKeyValueLibelle[]|undefined>([]);
  

    const paintSource = () => {
      const newTasks = source?.filter((elem: IKeyValueLibelle) => 
        !destinationTasks?.some(task => task.key === elem.key)
      ) || [];
      setSourceTasks(newTasks);
    }

    const paintDestination = () => {
      setDestinationTasks(destination);
    }

    useEffect(() => {
      paintSource();
    }, [source])

      useEffect(() => {
        paintDestination();
    }, [destination])

    useEffect(() => {
      paintSource();
    }, [destinationTasks])


  
    const valider = () => {
      if (destinationTasks !== destination && destinationTasks !== undefined) {
        cmdValider(destinationTasks);
      }
    }

    const annuler = () => {
      setSourceTasks([]);
      setDestinationTasks([]);
      cmdAnnuler();
    }

    const onDragEnd = (result: DropResult) => {
      const { source, destination } = result;
  
      // Si l'utilisateur dépose l'élément en dehors de la zone droppable
      if (!destination) {
        return;
      }
  
      // Vérifier que l'ID de la tâche est défini
      let sourceTaskList = source.droppableId === 'source' ? sourceTasks : destinationTasks;
      let destinationTaskList = destination.droppableId === 'source' ? sourceTasks : destinationTasks;
      const setSourceTaskList = source.droppableId === 'source' ? setSourceTasks : setDestinationTasks;
      const setDestinationTaskList = destination.droppableId === 'source' ? setSourceTasks : setDestinationTasks;
      
      sourceTaskList = sourceTaskList ?? [];
      destinationTaskList = destinationTaskList ?? [];

      const [movedTask] = sourceTaskList.splice(source.index, 1);
      destinationTaskList.splice(destination.index, 0, movedTask);
  
      setSourceTaskList([...sourceTaskList]);
      setDestinationTaskList([...destinationTaskList]);
    };

  
    const toutajouter = () => {
        setDestinationTasks([...destinationTasks ?? [], ...sourceTasks ?? []]);
        setSourceTasks([]);
    }

    const toutretirer = () => {
        setSourceTasks([...sourceTasks ?? [], ...destinationTasks ?? []]);
        setDestinationTasks([]);
    }

    // Retirer un élément spécifique de la destination
  const retirer = (task: IKeyValueLibelle) => {
    setSourceTasks([...sourceTasks ?? [], task]);
    setDestinationTasks(destinationTasks?.filter((t: IKeyValueLibelle) => t.key !== task.key) ?? []);
  };

  // Ajouter un élément spécifique à la destination
  const ajouter = (task: IKeyValueLibelle) => {
    setDestinationTasks([...destinationTasks ?? [], task]);
    setSourceTasks(sourceTasks?.filter((t: IKeyValueLibelle) => t.key !== task.key) ?? []);
  };

  
    

    
    return (
      <>
       <div className="card form-card">
       <div className="card-body">
       {/* /{(sourceTasks && sourceTasks?.length && sourceTasks?.length > 0 || destinationTasks && destinationTasks?.length && destinationTasks?.length > 0) ?  */}
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="lists p-2 m-b-4">
        <div className="row ">
        <div className="col-md-6 col-12">
            <div><b>{titresource} ({sourceTasks?.length})</b></div>
            <button type="button" className="btn " onClick={toutajouter} title='Tout ajouter' >
              <i className='bi bi-box-arrow-right text-green fs-1' />
            </button>
              <Droppable droppableId="source">
                  {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef} className="task-list w-100 " style={{ height: '40vh', overflowY: 'auto' }}>
                     {!sourceIsFetching ?
                    <>
                      {sourceTasks?.map((task, index) => (
                    <div key={task.value}>
                    <Draggable draggableId={task.value} index={index}>
                      {(provided) => (
                        <div
                          key={task.key}
                          data-tooltip-id={`tooltip-${task.key}`}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="task tasksource shadow"
                          style={{ ...provided.draggableProps.style }}
                        >
                          <b>{task.Libelle}</b>
                          <button
                            type="button"
                            className="btn ms-auto"
                            onClick={() => ajouter(task)}
                            title="ajouter"
                          >
                            <i className="bi bi-plus-square-fill fs-3 text-green" />
                          </button>
                        </div>
                      )}
                    </Draggable>
      
                    {/* Affichage du Tooltip avec un ID unique */}
                    <Tooltip
                      id={`tooltip-${task.key}`}
                      content={task.key}
                      place="top-end"
                      className="custom-tooltip"
                    />
                  </div>
                      ))}
                      {provided.placeholder}
                      </>
                      : 
                      <SpinnerEditeurPro />
                      }
                  </div>
                  )}
              </Droppable>
          </div>
          <div className="col-md-6 col-12">
            <div><b>{titredestination} ({destinationTasks?.length})</b></div>
            <button type="button" className="btn" onClick={toutretirer} title='Tout retirer' >
              <i className='bi bi-box-arrow-left text-reddark fs-1' />
            </button>
            
            <Droppable droppableId="destination">
                {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef} className="task-list w-100" style={{ height: '40vh', overflowY: 'auto' }}>
                  {!destinationIsFetching ? 
                  <>
                    {destinationTasks?.map((task, index) => (
                    <div key={task.value}>
                    <Draggable key={task.value} draggableId={task.value} index={index}>
                        {(provided) => (
                        <div
                            key={task.key}
                            data-tooltip-id={`tooltip-${task.key}`}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="task taskdestination shadow d-flex flex-row"
                            style={{ ...provided.draggableProps.style }}
                        >
                          <button type="button" className="btn" onClick={() => retirer(task)} title='retirer' ><i className='bi bi-dash-square-fill fs-3 text-reddark' /></button>
                          <b className=''>{task.Libelle}</b>
                        </div>
                        )}
                    </Draggable>
                          
                    {/* Affichage du Tooltip avec un ID unique */}
                    <Tooltip
                      id={`tooltip-${task.key}`}
                      content={task.key}
                      place="top-start"
                      className="custom-tooltip"
                    />
                  </div>
                    ))}
                    {provided.placeholder}
                    </>
                    : 
                    <SpinnerEditeurPro />
                  }
                </div>
                )}
            </Droppable>
          </div>
        </div>
        </div>
      </DragDropContext>
      <div className="d-flex gap-3 mt-3 justify-content-center">
        <button type="button" className="btn btn-outline-secondary" onClick={annuler}>
          <i className="bi bi-arrow-counterclockwise me-2"></i>
          Annuler les changements
        </button>
        <button type="button" className="btn btn-secondary" onClick={valider}>
          <i className="bi bi-check-circle me-2"></i>
          Valider les changements
        </button>
      </div>
      
      </div>
      </div>
      </>
    );
  };
  
  export default CpntDragAndDropLists;